import Vue from 'vue'
// import moment from 'moment'

const appUtils = {}

appUtils.install = function (Vue) {
    Vue.prototype.$utils = {
        serializeformData(data, bracketsForArray) {
            let obj = {};
            for (let [key, value] of data) {
                if (obj[key] !== undefined) {
                    if (!Array.isArray(obj[key])) {
                        obj[key] = [obj[key]];
                    }
                    obj[key].push(value);
                } else {
                    obj[key] = value;
                }
            }
            if (bracketsForArray) {
                for (let key in obj) {
                    if (key.endsWith('[]')) {
                        obj[key.slice(0, -2)] = obj[key]
                        delete obj[key]
                    }
                }
            }
            return obj;
        },
    }
}

Vue.use(appUtils)

